// extracted by mini-css-extract-plugin
module.exports = {"textLeft":"LandingPageLinkIndex_textLeft__1gLa4"};